import { createContext } from 'react';

const ConnectorContext = createContext({ services: [] });

export default ConnectorContext;
